import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { numberWithCommas } from 'common/formatters';

class SrResultsMatchedCard extends Component {
  static propTypes = {
    resultsCount: PropTypes.number.isRequired,
    totalListingsCount: PropTypes.number.isRequired,
  };

  render() {
    const { resultsCount, totalListingsCount } = this.props;

    return (
      <div>
        <span className="headline main">
          {resultsCount} results matched
          <div className="listingsTotalCountContainer">
            <span className="listingsTotalCount">
              out of {numberWithCommas(totalListingsCount)} homes &amp; apartments
            </span>
          </div>
        </span>
      </div>
    );
  }
}

SrResultsMatchedCard.displayName = 'SrResultsMatchedCard';

export default SrResultsMatchedCard;
